<template>
  <div
    :class="tabActiveClass"
    id="access"
    role="tabpanel"
    aria-labelledby="access-tab"
  >
    <h4 class="form-title hide-mobile">{{ transPeralbaPro.item818 }}</h4>
    <hr class="hide-mobile" />
    <div class="row">
      <div class="col-md-6">
        <h5 class="form-subtitle">{{ transPeralbaPro.item828 }}</h5>
        <p class="form-subtitle-p">{{ transPeralbaPro.item829 }}</p>
      </div>
      <div class="col-md-6">
        <form-input
          fieldName="email"
          :fieldLabel="transPeralbaPro.item793"
          fieldType="email"
          :fieldValue="email"
          :inputPlaceholder="transPeralbaPro.item794"
          :is-required="true"
          :has-error="fieldHasErrors('accessData', 'email')"
          @updateValue="updateFormValue"
        />
        <form-input-password
          fieldName="password"
          :fieldLabel="transPeralbaPro.item797"
          :fieldValue="password"
          :inputPlaceholder="transPeralbaPro.item798"
          :is-required="true"
          :has-error="fieldHasErrors('accessData', 'password')"
          @updateValue="updateFormValue"
        />

        <form-select
          fieldName="selectedLang"
          :fieldLabel="transPeralbaPro.item830"
          :fieldValue="selectedLang"
          :options="languages"
          :is-required="true"
          :has-error="fieldHasErrors('accessData', 'selectedLang')"
          @updateValue="updateFormValue"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h5 class="form-subtitle">{{ transPeralbaPro.item831 }}</h5>

        <form-check-box
          :fieldValue="newsletter"
          fieldName="newsletter"
          :fieldLabel="transPeralbaPro.item832"
          @updateValue="updateFormValue"
        />
        <form-check-box-list
          :fieldValue="newsletterInterests"
          fieldName="newsletterInterests"
          :options="activities"
          @updateValue="updateFormValue"
        />
        <form-check-box
          :fieldValue="whatsapp"
          fieldName="whatsapp"
          :fieldLabel="transPeralbaPro.item1278"
          @updateValue="updateFormValue"
        />

        <form-check-box
          :fieldValue="legal"
          fieldName="legal"
          :fieldLabel="legalText"
          :is-required="true"
          :has-error="fieldHasErrors('accessData', 'legal')"
          @updateValue="updateFormValue"
        />
      </div>
    </div>

    <div class="w-100" style="height: 100px">
      <button
        type="button"
        :disabled="disabledForm"
        class="btn-per-dark-outlined mt-4 mb-2"
        @click="$emit('goToDatosBancarios')"
        style="float: left"
      >
        <i class="fas fa-arrow-left me-3"></i>{{ transPeralbaPro.item833 }}
      </button>

      <button
        type="button"
        :disabled="disabledForm"
        class="btn-per-dark mt-4 mb-2"
        @click.prevent="$emit('crearCuenta')"
        style="float: right"
      >
        {{ transPeralbaPro.item834 }}
      </button>
    </div>
  </div>
</template>
<script>
import FormInput from "../../../../../components/front/Inputs/FormInput";
import FormCheckBox from "../../../../../components/front/Inputs/FormCheckBox";
import FormCheckBoxList from "../../../../../components/front/Inputs/FormCheckBoxList";
import FormInputPassword from "../../../../../components/front/Inputs/FormInputPassword";
import FormSelect from "../../../../../components/front/Inputs/FormSelect";

import sections from "../../mixins/sections";
export default {
  mixins: [sections],
  components: {
    FormInput,
    FormCheckBox,
    FormCheckBoxList,
    FormInputPassword,
    FormSelect,
  },
  props: [
    "activeTab",
    "email",
    "password",
    "languages",
    "selectedLang",
    "newsletter",
    "newsletterInterests",
    "whatsapp",
    "activities",
    "legal",
    "routeLegal",
    "routePrivacy",
    "disabledForm",
    "errors",
    "transPeralbaPro",
  ],
  computed: {
    legalText() {
      return (
        this.transPeralbaPro.item835 +
        `<a href="${this.routeLegal}" target="_blank">` +
        this.transPeralbaPro.item836 +
        `</a> ` +
        this.transPeralbaPro.item837 +
        ` <a href="${this.routePrivacy}" target="_blank">` +
        this.transPeralbaPro.item838 +
        `</a>`
      );
    },
  },
};
</script>
